import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation, Trans } from 'react-i18next';
import moment from "moment";
import Datetime from "react-datetime";

//components 
import Carousel from 'react-material-ui-carousel'
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Card from "beaktShared/components/Card/Card.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardFooter from "beaktShared/components/Card/CardFooter.js";
import Badge from "beaktShared/components/Badge/Badge.js";
import CustomDropdown from "beaktShared/components/CustomDropdown/CustomDropdown.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from '@material-ui/core/CircularProgress';
import VisualizarTodosFranqueados from "./VisualizarTodosFranqueados.js";
import VisualizarTodosContratosVencer from "./VisualizarTodosContratosVencer.js";
import VisualizarTodosContratosVencidos from "./VisualizarTodosContratosVencidos.js";
import VisualizarTodosRoyaltiesAjustados from "./VisualizarTodosRoyaltiesAjustados.js";
import Button from "beaktShared/components/CustomButtons/Button.js";

//graph
import PieGraph from './Graficos/PieGraph';
import Pie2Graph from './Graficos/Pie2Graph';
import LineGraph from './Graficos/LineGraph';
import BarGraph from './Graficos/BarGraph';
import Bar2Graph from './Graficos/Bar2Graph';

//icons
import Warning from "@material-ui/icons/Warning";
import ReportOff from "@material-ui/icons/ReportOff";
import Timeline from "@material-ui/icons/Timeline";
import TimerOff from "@material-ui/icons/TimerOff";
import BarChart from "@material-ui/icons/BarChart";
import PieChart from "@material-ui/icons/PieChart";

//services
import { MaskDate, validateDate, convertDate, formateDate, transformValueFloattoFormated, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";
import { UsePostApi, UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

//styles
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(styles);

export default function Dashboard() {
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);
  const { register, errors, setError, clearError, getValues } = useForm({ mode: "onBlur" });

  const [notification, setNotification] = React.useState({
    show: false,
    color: 'info',
    message: ''
  });
  const showNotification = (message, color) => {
    setNotification({
      show: true,
      color: color,
      message: message
    });
    setTimeout(function () {
      setNotification({ show: false });
    }, 6000);
  };

  useEffect(() => {
    loadDados();
  }, []);

  const loadDados = () => {
    loadMesAnos();
    loadVendas12();

    const dtini = moment(new Date()).add(-7, 'days');
    const dtfim = new Date();
    let obj = {
      dataIni: dtini,
      dataFim: dtfim
    }
    setperiodopesquisa(obj);
    loadQtdContratoxCanalMidia(obj);
    loadVendasxSexo(obj);
    loadTop5Estabelecimento(obj);
    loadRoyaltiePrevisaoxFaturado(obj);
    loadContratosAVencer();
    loadContratosVencidos();
    loadMinRoyaltiesAjustados();
  }

  const [loadingvendas12, setloadingvendas12] = React.useState(false);
  const [vendas12, setvendas12] = React.useState([]);
  const [totalizadorvendas12, settotalizadorvendas12] = React.useState({
    mesatual: 0, mespassado: 0
  });
  const loadVendas12 = () => {
    setloadingvendas12(true);
    const endPoint = "dashboard/totalizador12byfranquia/" + session.franquiaId;
    UseGetApiSimple(endPoint).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger')
        setloadingvendas12(false);
        return false;
      }
      setvendas12(result.data);
      if (result.data) {
        settotalizadorvendas12({
          mesatual: result.data[0].data[11].y,
          mespassado: result.data[0].data[10].y
        });
      }
      setloadingvendas12(false);
      return true;
    });
  }

  const [loadingqtdxcanal, setloadingqtdxcanal] = React.useState(false);
  const [dadosQtdContratoxCanalMidia, setdadosQtdContratoxCanalMidia] = React.useState([]);
  const loadQtdContratoxCanalMidia = (obj) => {
    setloadingqtdxcanal(true);
    const endPoint = "dashboard/contratoxgrupocanalmidia/" + session.franquiaId;
    UsePostApi(endPoint, obj).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger')
        setloadingqtdxcanal(false);
        return false;
      }
      setdadosQtdContratoxCanalMidia(result.data);
      setloadingqtdxcanal(false);
      return true;
    });
  }

  const [loadingvendaxsexo, setloadingvendaxsexo] = React.useState(false);
  const [dadosVendasxSexo, setdadosVendasxSexo] = React.useState([]);
  const loadVendasxSexo = (obj) => {
    setloadingvendaxsexo(true);
    const endPoint = "dashboard/vendaxsexo/0/" + session.franquiaId;
    UsePostApi(endPoint, obj).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger')
        setloadingvendaxsexo(false);
        return false;
      }
      setdadosVendasxSexo(result.data);
      setloadingvendaxsexo(false);
      return true;
    });
  }

  const [loadingTop5Estabelecimento, setloadingTop5Estabelecimento] = React.useState(false);
  const [dadosTop5Estabelecimento, setdadosTop5Estabelecimento] = React.useState([]);
  const loadTop5Estabelecimento = (obj) => {
    setloadingTop5Estabelecimento(true);
    const endPoint = "dashboard/top5estabelecimentobyvenda/" + session.franquiaId + "/" + 10;
    UsePostApi(endPoint, obj).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger')
        setloadingTop5Estabelecimento(false);
        return false;
      }
      setdadosTop5Estabelecimento(result.data);
      setloadingTop5Estabelecimento(false);
      return true;
    });
  }

  const [loadingFechamentobyStatus, setloadingFechamentobyStatus] = React.useState(false);
  const [dadosFechamentobyStatus, setdadosFechamentobyStatus] = React.useState([]);
  const loadFechamentobyStatus = (obj) => {
    setloadingFechamentobyStatus(true);
    const endPoint = "dashboard/fechamentobystatus/" + session.franquiaId;
    UsePostApi(endPoint, obj).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger')
        setloadingFechamentobyStatus(false);
        return false;
      }
      setdadosFechamentobyStatus(result.data);
      setloadingFechamentobyStatus(false);
      return true;
    });
  }

  const [loadingRoyaltiePrevisaoxFaturado, setloadingRoyaltiePrevisaoxFaturado] = React.useState(false);
  const [dadosRoyaltiePrevisaoxFaturado, setdadosRoyaltiePrevisaoxFaturado] = React.useState([]);
  const loadRoyaltiePrevisaoxFaturado = (obj) => {
    setloadingRoyaltiePrevisaoxFaturado(true);
    const endPoint = "dashboard/royaltieprevisaoxfaturado/" + session.franquiaId;
    UsePostApi(endPoint, obj).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger')
        setloadingRoyaltiePrevisaoxFaturado(false);
        return false;
      }
      setdadosRoyaltiePrevisaoxFaturado(result.data);
      setloadingRoyaltiePrevisaoxFaturado(false);
      return true;
    });
  }

  const [loadingContratosAVencer, setloadingContratosAVencer] = React.useState(false);
  const [dadosContratosAVencer, setdadosContratosAVencer] = React.useState([]);
  const loadContratosAVencer = () => {
    setloadingContratosAVencer(true);
    const endPoint = "dashboard/contratosavencer/" + session.franquiaId + "/" + 5;
    UsePostApi(endPoint, null).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger')
        setloadingContratosAVencer(false);
        return false;
      }
      setdadosContratosAVencer(result.data);
      setloadingContratosAVencer(false);
      return true;
    });
  }

  const [loadingContratosVencidos, setloadingContratosVencidos] = React.useState(false);
  const [dadosContratosVencidos, setdadosContratosVencidos] = React.useState([]);
  const loadContratosVencidos = () => {
    setloadingContratosVencidos(true);
    const endPoint = "dashboard/contratosvencidos/" + session.franquiaId + "/" + 10;
    UsePostApi(endPoint, null).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger')
        setloadingContratosVencidos(false);
        return false;
      }
      setdadosContratosVencidos(result.data);
      setloadingContratosVencidos(false);
      return true;
    });
  }

  const [anoAtual, setAnoAtual] = React.useState(new Date().getFullYear())
  const [loadingMinRoyatiesAjustados, setloadingMinRoyatiesAjustados] = React.useState(false);
  const [dadosMinRoyaltiesAjustados, setdadosMinRoyaltiesAjustados] = React.useState([]);
  const loadMinRoyaltiesAjustados = () => {
    setloadingMinRoyatiesAjustados(true);
    const endPoint = "dashboard/GetReajusteLog/" + session.franquiaId + "/" + 5;
    UsePostApi(endPoint, null).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger')
        setloadingMinRoyatiesAjustados(false);
        return false; 
      }
      setdadosMinRoyaltiesAjustados(result.data);
      setloadingMinRoyatiesAjustados(false);
      return true;
    });
  }

  const [periodos] = React.useState([
    <span id="0">{t('dashboard.last_7_days')}</span>,
    <span id="1">{t('dashboard.last_15_days')}</span>,
    <span id="2">{t('dashboard.last_30_days')}</span>
  ])
  const [periodo1, setperiodo1] = React.useState(null);
  const handlePeriodo1Change = (event) => {
    if (!event)
      return;

    let txt = event.props.children;
    let cod = event.props.id;
    setperiodo1(txt);

    let dtini = moment(new Date()).add(-7, 'days');
    if (cod === "1")
      dtini = moment(new Date()).add(-15, 'days');
    if (cod === "2")
      dtini = moment(new Date()).add(-30, 'days');
    const dtfim = new Date();
    let obj = {
      dataIni: dtini,
      dataFim: dtfim
    }
    loadQtdContratoxCanalMidia(obj);
    loadVendasxSexo(obj);
  }
  const [periodopesquisa, setperiodopesquisa] = React.useState([]);
  const [periodo2, setperiodo2] = React.useState(null);
  const handlePeriodo2Change = (event) => {
    if (!event)
      return;

    let txt = event.props.children;
    let cod = event.props.id;
    setperiodo2(txt);

    let dtini = moment(new Date()).add(-7, 'days');
    if (cod === "1")
      dtini = moment(new Date()).add(-15, 'days');
    if (cod === "2")
      dtini = moment(new Date()).add(-30, 'days');
    const dtfim = new Date();
    let obj = {
      dataIni: dtini,
      dataFim: dtfim
    }
    setperiodopesquisa(obj);
    loadTop5Estabelecimento(obj);
  }

  const [mesanos, setmesanos] = React.useState([])
  const loadMesAnos = () => {
    //setloadingRoyaltiePrevisaoxFaturado(true);       
    const endPoint = "dashboard/ultimosfechamentos/" + session.franquiaId;
    UseGetApiSimple(endPoint).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger')
        //setloadingRoyaltiePrevisaoxFaturado(false);
        return false;
      }
      result.data = result.data.map((val, index, array) => array[array.length - 1 - index]);
      setmesanos(result.data);
      //setloadingRoyaltiePrevisaoxFaturado(false);  
      //console.log(result.data) 
      setmesano(result.data[0])
      let objmesAno = {
        mesAno: result.data[0]
      }
      loadFechamentobyStatus(objmesAno);
      return true;
    });
  }
  const [mesano, setmesano] = React.useState(null);
  const handleMesAnoChange = (event) => {
    if (!event)
      return;

    let txt = event;
    setmesano(txt)
    let objmesAno = {
      mesAno: txt
    }
    loadFechamentobyStatus(objmesAno);
  }

  const [ShowModalFranqueados, setShowModalFranqueados] = React.useState(false);
  const handleModalFranqueados = () => {
    setShowModalFranqueados(true);
  }

  const [ShowModalContratosVencer, setShowModalContratosVencer] = React.useState(false);
  const handleModalContratosVencer = () => {
    setShowModalContratosVencer(true);
  }

  const [ShowModalContratosVencidos, setShowModalContratosVencidos] = React.useState(false);
  const handleModalContratosVencidos = () => {
    setShowModalContratosVencidos(true);
  }

  const [ShowModalReajusteRoyaltie, setShowModalReajusteRoyaltie] = React.useState(false);
  const handleModalReajusteRoyaltie = () => {
    setShowModalReajusteRoyaltie(true);
  }

  const [ShowPeriodoPersonalizado, setShowPeriodoPersonalizado] = React.useState(false);
  const [dtiniPersonalizado, setdtiniPersonalizado] = React.useState(formateDate(moment(new Date())));
  const [dtfimPersonalizado, setdtfimPersonalizado] = React.useState(formateDate(moment(new Date())));
  const monthDiff = (dateFrom, dateTo) => {
    return dateTo.getMonth() - dateFrom.getMonth() +
      (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
  }
  
  const handlePeriodoPersonalizado = () => {
    setShowPeriodoPersonalizado(true);
  }

  const handleClickPesquisa = () => {
    let data = getValues();

    if (data.dtiniPersonalizado === "") {
      setError("dtiniPersonalizado", "required", t('label.required'))
      return false;
    }
    else
      clearError("dtiniPersonalizado")

    if (data.dtfimPersonalizado === "") {
      setError("dtfimPersonalizado", "required", t('label.required'))
      return false;
    }
    else
      clearError("dtfimPersonalizado")

    if (!validateDate(data.dtiniPersonalizado)) {
      setError("dtiniPersonalizado", "invaliddate", t('error_message.invalid_date'))
      return false;
    }
    else
      clearError("dtiniPersonalizado")

    if (!validateDate(data.dtfimPersonalizado)) {
      setError("dtfimPersonalizado", "invaliddate", t('error_message.invalid_date'))
      return false;
    }
    else
      clearError("dtfimPersonalizado")

    let dataIniConvertida = convertDate(data.dtiniPersonalizado);
    let dataFimConvertida = convertDate(data.dtfimPersonalizado);

    if (monthDiff(dataIniConvertida, dataFimConvertida) > 3) {
      showNotification(t('error_message.select_3month'), 'danger')
      return false;
    }

    let obj = {
      dataIni: dataIniConvertida,
      dataFim: dataFimConvertida
    }
    setperiodopesquisa(obj);
    loadTop5Estabelecimento(obj);

  }

  return (
    <div>

      <GridContainer>

        <GridItem xs={12} sm={12} md={8} >
          <Card>
            <CardHeader icon>
              <CardIcon color="primary">
                <Timeline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t('dashboard.sales_last_12_months')}
              </h4>
            </CardHeader>
            <CardBody>
              <div style={{ float: 'left', marginLeft: '10px' }}>
                <h4 style={{ marginBottom: '0px' }}>{t('label.money_symbol')} {transformValueFloattoFormated(totalizadorvendas12.mesatual ? totalizadorvendas12.mesatual : 0)}</h4>
                <small>{t('dashboard.current_month')}</small>
              </div>
              <div style={{ float: 'left', marginLeft: '10px', borderLeft: '1px dashed #ccc', paddingLeft: '10px' }}>
                <h4 style={{ marginBottom: '0px' }}>{t('label.money_symbol')} {transformValueFloattoFormated(totalizadorvendas12.mespassado ? totalizadorvendas12.mespassado : 0)}</h4>
                <small>{t('dashboard.last_month')}</small>
              </div>
              <div style={{ clear: 'both' }}></div>
              <div style={{ height: '250px' }}>
                {loadingvendas12 && <div className="loadingDash"><CircularProgress size={40} /></div>}
                {(!loadingvendas12 && vendas12.length > 0) &&
                  <LineGraph data={vendas12} />
                }
                {(!loadingvendas12 && vendas12.length == 0) &&
                  <div className="showNoData">
                    <TimerOff style={{ fontSize: '40px' }} />
                    <h4>
                      <Trans i18nKey="dashboard.message_no_data">
                        Oops,<br />Não há dados nesse período.
                      </Trans>
                    </h4>
                  </div>}
              </div>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={12} md={4} >
          <Card>
            <CardHeader icon>

              <div className="btactionr">
                <CustomDropdown
                  hoverColor="info"
                  buttonProps={{
                    fullWidth: true,
                    style: { marginBottom: "0" },
                    color: "info",
                    size: "sm"
                  }}
                  buttonText={periodo1 ? periodo1 : periodos[0].props.children}
                  onClick={handlePeriodo1Change}
                  dropdownHeader={t('label.period')}
                  dropdownList={periodos}
                />
              </div>

            </CardHeader>
            <CardBody style={{ marginTop: '35px' }}>

              <Carousel
                className="Example"
                autoPlay={true}
                timer={200}
                animation={true}
                indicators={true}
                timeout={200}
                navButtonsAlwaysVisible={false}>
                <div style={{ width: '100%' }} >
                  <center><label style={{ fontWeight: '400' }}> {t('dashboard.contracts_x_media')} </label></center>
                  <br />
                  <div style={{ height: '230px' }}>
                    {loadingqtdxcanal && <div className="loadingDash"><CircularProgress size={40} /></div>}
                    {(!loadingqtdxcanal && dadosQtdContratoxCanalMidia.length > 0) &&
                      <Pie2Graph data={dadosQtdContratoxCanalMidia} />
                    }
                    {(!loadingqtdxcanal && dadosQtdContratoxCanalMidia.length == 0) &&
                      <div className="showNoData">
                        <TimerOff style={{ fontSize: '40px' }} />
                        <h4>
                          <Trans i18nKey="dashboard.message_no_data">
                            Oops,<br />Não há dados nesse período.
                          </Trans>
                        </h4>
                      </div>}
                  </div>
                </div>
                <div style={{ width: '100%' }} >
                  <center><label style={{ fontWeight: '400' }}>  {t('dashboard.sales_x_sex')} </label></center>
                  <br />
                  <div style={{ height: '230px' }}>
                    {loadingvendaxsexo && <div className="loadingDash"><CircularProgress size={40} /></div>}
                    {(!loadingvendaxsexo && dadosVendasxSexo.length > 0) &&
                      <Pie2Graph data={dadosVendasxSexo} />
                    }
                    {(!loadingvendaxsexo && dadosVendasxSexo.length == 0) &&
                      <div className="showNoData">
                        <TimerOff style={{ fontSize: '40px' }} />
                        <h4>
                          <Trans i18nKey="dashboard.message_no_data">
                            Oops,<br />Não há dados nesse período.
                          </Trans>
                        </h4>
                      </div>}
                  </div>
                </div>
              </Carousel>

            </CardBody>
          </Card>
        </GridItem>

      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader icon>
              <GridContainer>
                <GridItem xs={12} sm={8} md={8}>
                  <CardIcon color="primary">
                    <BarChart />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    {t('dashboard.top_10_franchisees_by_sales')}
                  </h4>
                </GridItem>
                <GridItem xs={12} sm={2} md={2}>
                  <Button onClick={() => handlePeriodoPersonalizado()} color="primary" className={classes.updateProfileButton} size="sm" style={{ marginTop: '15px' }}>
                    {t('dashboard.custom')}
                  </Button>
                </GridItem>
                <GridItem xs={12} sm={1} md={1}>
                  <div className="btactionr">
                    <CustomDropdown
                      hoverColor="info"
                      buttonProps={{
                        fullWidth: true,
                        style: { marginBottom: "0" },
                        color: "info",
                        size: "sm"
                      }}
                      buttonText={periodo2 ? periodo2 : periodos[0].props.children}
                      onClick={handlePeriodo2Change}
                      dropdownHeader={t('label.period')}
                      dropdownList={periodos}
                    />
                  </div>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
            {ShowPeriodoPersonalizado &&
                <GridContainer>
                  <GridItem xs={12} sm={5} md={3}>
                    <FormControl fullWidth >
                      <label className={errors.dtiniPersonalizado ? "select__label select__label_error" : "select__label"}>
                        {t('label.ini_date') + " *"}  </label>
                      <Datetime
                        locale={getLocale()}
                        dateFormat={getStringFormatDate()}
                        timeFormat={false}
                        name="dtiniPersonalizado"
                        defaultValue={dtiniPersonalizado}
                        value={dtiniPersonalizado}
                        onChange={date => { setdtiniPersonalizado(date) }}
                        inputProps={{ name: "dtiniPersonalizado", ref: register({ required: true }), readOnly: 'readonly' }}
                        className={errors.dtiniPersonalizado ? "error" : ""}
                      />
                      {errors.dtiniPersonalizado && <FormHelperText className={classes.labelRootError}>
                        <span> {errors.dtiniPersonalizado.message} </span>
                      </FormHelperText>}
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={5} md={3}>
                    <FormControl fullWidth >
                      <label className={errors.dtfimPersonalizado ? "select__label select__label_error" : "select__label"}>
                        {t('label.end_date') + " *"}  </label>
                      <Datetime
                        locale={getLocale()}
                        dateFormat={getStringFormatDate()}
                        timeFormat={false}
                        name="dtfimPersonalizado"
                        defaultValue={dtfimPersonalizado}
                        value={dtfimPersonalizado}
                        onChange={date => { setdtfimPersonalizado(date) }}
                        inputProps={{ name: "dtfimPersonalizado", ref: register({ required: true }), readOnly: 'readonly' }}
                        className={errors.dtfimPersonalizado ? "error" : ""}
                      />
                      {errors.dtfimPersonalizado && <FormHelperText className={classes.labelRootError}>
                        <span> {errors.dtfimPersonalizado.message} </span>
                      </FormHelperText>}
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={2} md={2}>
                    <Button type="submit" onClick={() => handleClickPesquisa()} color="primary" className={classes.updateProfileButton}>
                      {t('button.search')}
                    </Button>
                  </GridItem>
                </GridContainer>
              }<br></br>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6} >
                  {loadingTop5Estabelecimento && <div className="loadingDash"><CircularProgress size={40} /></div>}
                  {(!loadingTop5Estabelecimento && dadosTop5Estabelecimento.length > 0) &&
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>{t('dashboard.ranking')}</th>
                          <th>{t('label.establishment')}</th>
                          <th>{t('label.money_symbol')} {t('label.total')}</th>
                          <th>{t('dashboard.sales_qty')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dadosTop5Estabelecimento.map((item, index) => (
                          <tr key={item.estabelecimentoId}>
                            <td style={{ textAlign: 'center' }}>{(index + 1)}º</td>
                            <td>{item.estabelecimento}</td>
                            <td style={{ textAlign: 'right' }}>{transformValueFloattoFormated(item.total)}</td>
                            <td style={{ textAlign: 'center' }}><Badge color="success">{item.qtd}</Badge></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  }

                  {(!loadingTop5Estabelecimento && dadosTop5Estabelecimento.length == 0) &&
                    <div className="showNoData">
                      <TimerOff style={{ fontSize: '40px' }} />
                      <h4>
                        <Trans i18nKey="dashboard.message_no_data">
                          Oops,<br />Não há dados nesse período.
                        </Trans>
                      </h4>
                    </div>}
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <div style={{ height: '280px' }}>
                    {loadingTop5Estabelecimento && <div className="loadingDash"><CircularProgress size={40} /></div>}
                    {(!loadingTop5Estabelecimento && dadosTop5Estabelecimento.length > 0) &&
                      <Bar2Graph data={dadosTop5Estabelecimento} />
                    }
                    {(!loadingTop5Estabelecimento && dadosTop5Estabelecimento.length == 0) &&
                      <div className="showNoData">
                        <TimerOff style={{ fontSize: '40px' }} />
                        <h4>
                          <Trans i18nKey="dashboard.message_no_data">
                            Oops,<br />Não há dados nesse período.
                          </Trans>
                        </h4>
                      </div>}
                  </div>
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter>
              <div className={classes.stats}>
                <a href="#pablo" onClick={() => handleModalFranqueados()}>
                  {t('dashboard.view_all')}
                </a>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>

      <GridContainer>

        <GridItem xs={12} sm={12} md={5} >
          <Card>
            <CardHeader icon>
              <CardIcon color="primary">
                <PieChart />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t('information_message.royalties_closing')}
              </h4>

              <div className="btactionr">
                <CustomDropdown
                  hoverColor="info"
                  buttonProps={{
                    fullWidth: true,
                    style: { marginBottom: "0" },
                    color: "info",
                    size: "sm"
                  }}
                  buttonText={mesano ? mesano : ''}
                  onClick={handleMesAnoChange}
                  dropdownHeader={t('label.month_year')}
                  dropdownList={mesanos}
                />
              </div>
            </CardHeader>
            <CardBody style={{ height: '350px' }}>

              {loadingFechamentobyStatus && <div className="loadingDash"><CircularProgress size={40} /></div>}
              {(!loadingFechamentobyStatus && dadosFechamentobyStatus.length > 0) &&
                <PieGraph data={dadosFechamentobyStatus} />
              }
              {(!loadingFechamentobyStatus && dadosFechamentobyStatus.length == 0) &&
                <div className="showNoData">
                  <TimerOff style={{ fontSize: '40px' }} />
                  <h4>
                    <Trans i18nKey="dashboard.message_no_data">
                      Oops,<br />Não há dados nesse período.
                    </Trans>
                  </h4>
                </div>}
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={12} md={7} >
          <Card>
            <CardHeader icon>
              <CardIcon color="primary">
                <BarChart />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t('dashboard.royalties_billing')}
              </h4>
            </CardHeader>
            <CardBody style={{ height: '350px' }}>

              {loadingRoyaltiePrevisaoxFaturado && <div className="loadingDash"><CircularProgress size={40} /></div>}
              {(!loadingRoyaltiePrevisaoxFaturado && dadosRoyaltiePrevisaoxFaturado.length > 0) &&
                <BarGraph data={dadosRoyaltiePrevisaoxFaturado} />
              }
              {(!loadingRoyaltiePrevisaoxFaturado && dadosRoyaltiePrevisaoxFaturado.length == 0) &&
                <div className="showNoData">
                  <TimerOff style={{ fontSize: '40px' }} />
                  <h4>
                    <Trans i18nKey="dashboard.message_no_data">
                      Oops,<br />Não há dados nesse período.
                    </Trans>
                  </h4>
                </div>}


            </CardBody>
          </Card>
        </GridItem>

      </GridContainer>

      <GridContainer>

        <GridItem xs={12} sm={6} md={6} >
          <Card>
            <CardHeader icon>
              <CardIcon color="primary">
                <Warning />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t('dashboard.contracts_close_to_deadline')}
              </h4>
            </CardHeader>
            <CardBody style={{ height: '400px' }}>

              {loadingContratosAVencer && <div className="loadingDash"><CircularProgress size={40} /></div>}
              {(!loadingContratosAVencer && dadosContratosAVencer.length > 0) &&
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>{t('label.establishment')} </th>
                      <th>{t('dashboard.contract_validity')}</th>
                      <th>{t('dashboard.days_to_expiration')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dadosContratosAVencer.map((item, index) => (
                      <tr key={item.estabelecimentoId}>
                        <td>{item.estabelecimento}</td>
                        <td style={{ textAlign: 'center' }}>{formateDate(item.dataValidade)}</td>
                        <td style={{ textAlign: 'center' }}><Badge color="warning">{item.diasParaVencimento}</Badge></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              }
              {(!loadingContratosAVencer && dadosContratosAVencer.length == 0) &&
                <div className="showNoData">
                  <TimerOff style={{ fontSize: '40px' }} />
                  <h4>
                    <Trans i18nKey="dashboard.message_no_data">
                      Oops,<br />Não há dados nesse período.
                    </Trans>
                  </h4>
                </div>}

            </CardBody>
            <CardFooter>
              <div className={classes.stats}>
                <a href="#pablo" onClick={() => handleModalContratosVencer()}>
                  {t('dashboard.view_all')}
                </a>
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={6} >
          <Card>
            <CardHeader icon>
              <CardIcon color="primary">
                <ReportOff />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t('dashboard.status_5_expired_contracts')}
              </h4>
            </CardHeader>
            <CardBody style={{ height: '400px' }}>
              {loadingContratosVencidos && <div className="loadingDash"><CircularProgress size={40} /></div>}
              {(!loadingContratosVencidos && dadosContratosVencidos.length > 0) &&
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>{t('label.establishment')} </th>
                      <th>{t('dashboard.contract_validity')}</th>
                      <th>{t('dashboard.days_overdue')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dadosContratosVencidos.map((item, index) => (
                      <tr key={item.estabelecimentoId}>
                        <td>{item.estabelecimento}</td>
                        <td style={{ textAlign: 'center' }}>{formateDate(item.dataValidade)}</td>
                        <td style={{ textAlign: 'center' }}><Badge color="danger">{item.diasVencidos}</Badge></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              }
              {(!loadingContratosVencidos && dadosContratosVencidos.length == 0) &&
                <div className="showNoData">
                  <TimerOff style={{ fontSize: '40px' }} />
                  <h4>
                    <Trans i18nKey="dashboard.message_no_data">
                      Oops,<br />Não há dados nesse período.
                    </Trans>
                  </h4>
                </div>}

            </CardBody>
            <CardFooter>
              <div className={classes.stats}>
                <a href="#pablo" onClick={() => handleModalContratosVencidos()}>
                  {t('dashboard.view_all')}
                </a>
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        {ShowModalFranqueados && <VisualizarTodosFranqueados closemodal={() => setShowModalFranqueados(false)} showmodal={ShowModalFranqueados} periodo={periodopesquisa} />}
        {ShowModalContratosVencer && <VisualizarTodosContratosVencer closemodal={() => setShowModalContratosVencer(false)} showmodal={ShowModalContratosVencer} />}
        {ShowModalContratosVencidos && <VisualizarTodosContratosVencidos closemodal={() => setShowModalContratosVencidos(false)} showmodal={ShowModalContratosVencidos} />}
        {ShowModalReajusteRoyaltie && <VisualizarTodosRoyaltiesAjustados closemodal={() => setShowModalReajusteRoyaltie(false)} showmodal={ShowModalReajusteRoyaltie} />}

        <GridItem xs={12} sm={8} md={10} >
          <Card>
            <CardHeader icon>
              <CardIcon color="primary">
                <Warning />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t('dashboard.adjusted_royaltie')}
              </h4>
            </CardHeader>
            <CardBody style={{ height: '500px' }}>
              <div style={{ float: 'left', marginLeft: '10px', marginBottom: '10px' }}>
                <h4 style={{ marginBottom: '0px'}}> <small>{"Ano referente -"} {anoAtual}</small> </h4>
                
              </div>
               <div style={{ height: '50px' }}> 
              {loadingMinRoyatiesAjustados && <div className="loadingDash"><CircularProgress size={40} /></div>}
              {(!loadingMinRoyatiesAjustados && dadosMinRoyaltiesAjustados.length > 0) &&
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>{t('label.establishment')} </th>
                      <th>{t('dashboard.month_year_birthday')}</th>
                      <th>{t('dashboard.minRoyalties_previous')}</th>
                      <th>{t('dashboard.minRoyalties_adjusted')}</th>
                      <th>{t('dashboard.maxRoyalties_previous')}</th>
                      <th>{t('dashboard.maxRoyalties_adjusted')}</th>
                      <th>{t('dashboard.accrued_annual_fee')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dadosMinRoyaltiesAjustados.map((item, index) => (
                      <tr key={item.estabelecimentoId}>
                        <td>{item.estabelecimento}</td>
                        <td style={{ textAlign: 'center' }}>{item.aniversario}</td>
                        <td style={{ textAlign: 'center' }}>{transformValueFloattoFormated(item.minRoyaltiesAnterior)}</td>
                        <td style={{ textAlign: 'center' }}>{transformValueFloattoFormated(item.minRoyaltiesCorrigido)}</td>
                        <td style={{ textAlign: 'center' }}>{transformValueFloattoFormated(item.maxRoyaltiesAnterior)}</td>
                        <td style={{ textAlign: 'center' }}>{transformValueFloattoFormated(item.maxRoyaltiesCorrigido)}</td>
                        <td style={{ textAlign: 'center' }}>{transformValueFloattoFormated(item.taxaAnualAcumulada)}{"%"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              }
              </div>
              {(!loadingMinRoyatiesAjustados && dadosMinRoyaltiesAjustados.length == 0) &&
                <div className="showNoData">
                  <TimerOff style={{ fontSize: '40px' }} />
                  <h4>
                    <Trans i18nKey="dashboard.message_no_data">
                      Oops,<br />Não há dados nesse período.
                    </Trans>
                  </h4>
                </div>}

            </CardBody>
            <CardFooter>
              <div className={classes.stats}>
                <a href="#pablo" onClick={() => handleModalReajusteRoyaltie()}>
                  {t('dashboard.view_all')}
                </a>
              </div>
            </CardFooter>
          </Card>
        </GridItem>

      </GridContainer>

    </div>
  );
}
